import { useSelector } from 'react-redux'
import useLoadControllingArbeitspakete from '../../../hooks/Controlling/useLoadControllingArbeitspakete'
import props from '../../../../redux/props'
import Add from './Add'
import Dropdown from '../../../UI/Dropdown/Dropdown'
import { Arbeitspaket } from '../../../../types/Controlling/Arbeitspaket'
import useGetOfferEntryName from '../../../hooks/Controlling/useGetOfferEntryName'
import { OfferEntry } from '../../../../types/Controlling/OfferEntry'

type Props = {
  value: string
  onChange: (value: string) => void
}

const ArbeitspaketSelection: React.FC<Props> = ({ value, onChange }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const getOfferEntryName = useGetOfferEntryName()
  const [arbeitspakete] = useLoadControllingArbeitspakete()

  const getArbeitspaketLabel = (arbeitspaket: Arbeitspaket) => {
    return getOfferEntryName({
      arbeitspaketUUID: arbeitspaket.uuid,
    } as OfferEntry)
  }

  if (!arbeitspakete) return null
  return (
    <div className="mt-1">
      <div className="text-gray text-sm">{t.controlling.arbeitspaketSelection.title}</div>
      <div className="flex gap-2">
        <Dropdown items={arbeitspakete.map((a) => ({ label: getArbeitspaketLabel(a), value: a.uuid }))} value={value} onChange={onChange} required />
        <Add callback={onChange} />
      </div>
    </div>
  )
}

export default ArbeitspaketSelection
